import { Component, OnInit } from '@angular/core';

import { IWidgetEditor, WidgetType, IMultiSourceMultiValueWidget, TimeSeriesDetail } from "src/app/models/dashboard";

import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { IconService } from 'src/service/icon.service';
import { Widget, Dashboard } from 'src/api/models'
import { StorageTablesService } from "src/service/storage-tables.service";

@Component({
  selector: 'app-variance-widget-editor',
  templateUrl: './variance-widget-editor.component.html',
  styleUrls: ['./variance-widget-editor.component.css']
})
export class VarianceWidgetEditorComponent implements OnInit, IWidgetEditor {
    public widgetType: WidgetType;
    public widget: any;
    public dashboard: Dashboard;
    public w: IMultiSourceMultiValueWidget;
    
    constructor(private iconService: IconService) { }

    ngOnInit() {
      this.w = <any>this.widget;
      if (!this.w.timeSeriesList || this.w.timeSeriesList.length != 2){
        this.w.timeSeriesList = [
          new TimeSeriesDetail(),
          new TimeSeriesDetail()
        ];
      }
      // get the latest data sources
    }

}
